import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  width: "682.667",
  height: "682.667",
  viewBox: "0 0 512 512"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M192.3 22.1c-4 1.2-124 115.4-126.7 120.6-2.1 4.2-1.8 10.8.8 14.7 2.1 3.3 119.2 115.2 123.1 117.8 4 2.6 12.9 2.1 17.2-1 6.2-4.4 6.3-5.2 6.3-45.6V192h81.3c87.8 0 92 .2 108 5.4 38.2 12.6 67.2 44.9 75.3 83.9.8 4 1.8 12.1 2.3 18 .8 11.5 1.8 13.9 7.5 18.1 2 1.6 4.2 2.1 8.6 2.1 6.3 0 9.5-1.6 13.4-6.9 2-2.6 2.1-4 2.1-30.4 0-18.3-.5-30.2-1.3-35.2-6.4-36.6-21.9-66.7-47.2-92-13.5-13.4-25.9-22.3-43.5-30.9-14.7-7.3-23.9-10.6-40.2-14.3-9.5-2.1-11.9-2.2-87.8-2.7l-78-.6-.5-37.7c-.5-36.3-.6-37.8-2.6-40.5-4.1-5.4-11.8-8.1-18.1-6.2z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M9.5 193.4c-4.2 1.8-8.3 6.9-9.1 11.2-1.2 6.5.3 54.3 2 63.3C9.1 303.4 24.2 332.2 49 357c22.7 22.6 50.7 37.8 83.5 45.1 9.8 2.2 11.8 2.3 88 2.8l78 .6.5 37.5c.4 27.3.8 38.1 1.7 39.7 1.9 3.2 6.1 6.2 10.4 7.3 8.5 2.3 6.8 3.7 72.6-59.1 36.1-34.5 61.6-59.5 62.7-61.6 2.1-4.2 1.8-10.8-.8-14.8-2.1-3.3-119.2-115.2-123.1-117.7-4-2.6-12.9-2.1-17.2 1-6.2 4.4-6.3 5.2-6.3 45.6V320h-81.2c-48.5 0-84.1-.4-88.3-1-43-6.2-78.7-35.8-92-76.5-3.1-9.5-4.3-16.3-5.4-29.9-.8-11.4-1.9-13.8-7.3-17.9-3.3-2.5-11.3-3.2-15.3-1.3z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };